import Vue from 'vue';

export default Vue.extend({
  computed: {
    activePermissionNames(): string[] {
      return this.$store.getters['sPermissions/activePermissionNames'] || [];
    },
  },
  methods: {
    /**
     * Each permission should be passed as a single argument. eg.
     * hasPermissions('users.read', 'voyages.delete', 'boards.write')
     * if you have an array of permissions, spread them like so:
     * hasPermissions(...userPermissions)
     */
    hasPermissions(...permissions: string[]): boolean {
      return permissions.every((permission) => this.activePermissionNames.includes(permission));
    },
  },
});
